import * as React from 'react';

import { cn } from '@/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        `autofill-bg-foreground border-input bg-foreground ring-offset-background placeholder:text-muted-foreground flex
        h-10 w-full rounded-md border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium
        focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:outline-0 disabled:cursor-not-allowed
        disabled:opacity-50`,
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export { Input };
